import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { getDisciplines, createDiscipline } from "../lib/api/disciplines";
import type { Discipline } from "../lib/api/disciplines";

export function useDisciplines(token: string | null, schoolProfileId?: string) {
  const queryClient = useQueryClient();

  const query = useQuery<Discipline[]>({
    queryKey: ["disciplines", schoolProfileId],
    queryFn: () => getDisciplines(token!, schoolProfileId),
    enabled: !!token && !!schoolProfileId,
  });

  const mutation = useMutation({
    mutationFn: (data: { name: string; school_profile_id: string }) =>
      createDiscipline(token!, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["disciplines", schoolProfileId] });
    },
  });

  return {
    ...query,
    createDiscipline: mutation.mutateAsync,
    isCreating: mutation.isPending,
  };
}
